<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-10-12 18:00:54
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-02-24 19:13:32
 * @FilePath: \seller.sviptrader.com\src\components\business\applySampleDrawer\components\confirmCooGoods\components\goodsBox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row-align-center font-h6-regular">
		<yx-avatar :src="row.head" :size="36" />
		<div class="ml-8 right">
			<p class="line-ellipsis-1 color-gy-9 fz-14 yx-pingfang-Medium">
				<platform-icon :platformId="row.platform_id"></platform-icon>
				{{ row.anchor_name }}
			</p>
			<p class="yx-color-text-secondary">{{ row.platform_id | formatPlatformName('unify') }}：{{ anchorAccount }}</p>
		</div>
	</div>
</template>
<script>
export default {
	components: {},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {};
	},
	computed: {
		isTipShopName({ row }) {
			let name = row.shopName;
			return name && name.length > 6 ? false : true;
		},
		anchorAccount() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.row.anchor_account,
				[dataMap.PLATFORM_KS.value]: this.row.anchor_account,
			};
			return temPF[this.row.platform_id];
		},
	},
};
</script>
<style lang="less" scoped>
.right {
	line-height: 20px;
}
</style>
